export default __webpack_public_path__ + "static/media/pak1.f77a6014.jpg";